import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { MdEdit } from "react-icons/md";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import iicon from "../../assets/i.svg";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import Loader from "../../Components/Loader/Loader";
import {
  EmailCheck,
  FirstNameCheck,
  onlyNumberCheck,
} from "../../ConditionChecks/ConditionChecks";
import { BusinessInfoAPI } from "../../Utils/Api/UserProfile";
import { userId } from "../../Utils/LocalStorage";

// import "froala-editor/css/froala_editor.pkgd.min.css";
// import "froala-editor/css/froala_style.css";
// import "froala-editor/js/plugins.pkgd.min.js";
import FroalaEditor from "react-froala-wysiwyg";
import { FroalaTextEditor } from "../../Components/FroalaEditor/FroalaTextEditor";
import { stripHTML } from "../../Components/FroalaEditor/StripHtml";
import { constant } from "../../Utils/Constant";
import { ErrorMessage } from "../../Utils/ErrorMsg/ErrorMsg";

const MyProfileBusinessInfo = () => {
  const [UserData, setUserData] = useState([]);
  const [editFlag, setEditFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [selectedCertifications, setSelectedCertifications] = useState([]);
  const max_character_count = 2000;

  const [userInput, setUserInput] = useState({
    editBusinessName: "",
    editBusinessCategory: "",
    editNumberOfEmployees: "",
    editBusinessRegistrationNo: "",
    editCompanyProfile: "",
    editBusinessEmail: "",
    editBusinessContact: "",
    editMetaTitle: "",
    editMetaDescription: "",
  });

  const [err_Display, setErr_Display] = useState({
    errBusinessName: "",
    errBusinessCategory: "",
    errNumberOfEmployees: "",
    errBusinessRegistrationNo: "",
    errCompanyProfile: "",
    errBusinessEmail: "",
    errBusinessContact: "",
    errBusinessCertification: "",
    errMetaTitle: "",
    errMetaDescription: "",
  });

  const [editInputFlag, setEditInputFlag] = useState({
    editFlagBusinessName: false,
    editFlagBusinessCategory: false,
    editFlagNumberOfEmployees: false,
    editFlagBusinessRegistrationNo: false,
    editFlagCompanyProfile: false,
    editFlagBusinessEmail: false,
    editFlagBusinessContact: false,
    editFlagBusinessCertification: false,
    editFlagMetaTitle: false,
    editFlagMetaDescription: false,
  });

  const businessCertification = [
    "LGBTQ+",
    "Minority",
    "Veteran",
    "Women Owned",
    "None Of The Above",
  ];

  const Bu_Id = userId();

  const CancelHandler = () => {
    setUserInput((prevState) => {
      return { ...prevState, editBusinessName: UserData.business_name };
    });

    setUserInput((prevState) => {
      return { ...prevState, editBusinessCategory: "" };
    });

    setUserInput((prevState) => {
      return {
        ...prevState,
        editNumberOfEmployees: UserData.number_of_employee,
      };
    });

    setSelectedCertifications(UserData.owned_gender);

    setUserInput((prevState) => {
      return {
        ...prevState,
        editBusinessRegistrationNo: UserData.business_registration_no,
      };
    });

    setUserInput((prevState) => {
      return { ...prevState, editCompanyProfile: UserData.company_profile };
    });

    setUserInput((prevState) => {
      return {
        ...prevState,
        editBusinessEmail: UserData.business_contact_email,
      };
    });

    setUserInput((prevState) => {
      return {
        ...prevState,
        editBusinessContact: UserData.business_contact_mobile,
      };
    });

    setUserInput((prevState) => {
      return {
        ...prevState,
        editMetaTitle: UserData.meta_title,
      };
    });

    setUserInput((prevState) => {
      return {
        ...prevState,
        editMetaDescription: UserData.meta_description,
      };
    });

    setEditFlag(false);
    window.scrollTo(0, 0);

    setErr_Display(() => {
      return {
        errBusinessName: "",
        errBusinessCategory: "",
        errBusinessRegistrationNo: "",
        errCompanyProfile: "",
        errNumberOfEmployees: "",
        errBusinessEmail: "",
        errBusinessContact: "",
        errBusinessCertification: "",
        errMetaTitle: "",
        errMetaDescription: "",
      };
    });
  };

  const EditHandler = () => {
    setEditFlag(true);
    // window.scrollTo({
    //   top: document.body.scrollHeight,
    //   left: 0,
    //   behavior: "smooth",
    // });
  };

  const onBusinessName = (e) => {
    setUserInput((prevState) => {
      return { ...prevState, editBusinessName: e.target.value };
    });
    setEditInputFlag((prevState) => {
      return { ...prevState, editFlagBusinessName: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errBusinessName: "" };
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    let updatedCertifications = [];

    if (name === "None Of The Above") {
      if (checked) {
        updatedCertifications = ["None Of The Above"];
      }
    } else {
      updatedCertifications = checked
        ? selectedCertifications
            .filter((cert) => cert !== "None Of The Above")
            .concat(name)
        : selectedCertifications.filter((cert) => cert !== name);
    }

    setSelectedCertifications(updatedCertifications);

    setErr_Display((prevState) => ({
      ...prevState,
      errBusinessCertification:
        updatedCertifications.length === 0
          ? "Please select at least one certification!"
          : "",
    }));
  };

  const onMetaTitle = (e) => {
    setUserInput((prevState) => {
      return { ...prevState, editMetaTitle: e.target.value };
    });
    setEditInputFlag((prevState) => {
      return { ...prevState, editFlagMetaTitle: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errMetaTitle: "" };
    });
  };

  const onMetaDescription = (e) => {
    setUserInput((prevState) => {
      return { ...prevState, editMetaDescription: e.target.value };
    });
    setEditInputFlag((prevState) => {
      return { ...prevState, editFlagMetaDescription: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errMetaDescription: "" };
    });
  };

  const onBusinessEmail = (e) => {
    setUserInput((prevState) => {
      return { ...prevState, editBusinessEmail: e.target.value };
    });
    setEditInputFlag((prevState) => {
      return { ...prevState, editFlagBusinessEmail: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errBusinessEmail: "" };
    });
  };

  const formatPhoneNumber = (value) => {
    let digits = value.replace(/\D/g, "");
    digits = digits.substring(0, 10);
    let formatted = digits;
    if (digits.length > 3) {
      formatted = digits.substring(0, 3) + "-" + digits.substring(3);
    }
    if (digits.length > 6) {
      formatted = formatted.substring(0, 7) + "-" + formatted.substring(7);
    }

    return formatted;
  };

  const validatePhoneNumber = (value) => {
    let digits = value.replace(/\D/g, "");
    return digits.length === 10;
  };

  const onBusinessContact = (event) => {
    let formattedValue = formatPhoneNumber(event.target.value);
    setMobileNumber(formattedValue);
    setEditInputFlag((prevState) => {
      return { ...prevState, editFlagBusinessContact: true };
    });
    if (!validatePhoneNumber(formattedValue)) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errBusinessContact: "Please enter a valid mobile number!",
        };
      });
    } else {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errBusinessContact: "",
        };
      });
    }
  };

  const onNumberOfEmployees = (e) => {
    setUserInput((prevState) => {
      return { ...prevState, editNumberOfEmployees: e.target.value };
    });
    setEditInputFlag((prevState) => {
      return { ...prevState, editFlagNumberOfEmployees: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errNumberOfEmployees: "" };
    });
  };

  const onBusinessRegistrationNo = (e) => {
    setUserInput((prevState) => {
      return { ...prevState, editBusinessRegistrationNo: e.target.value };
    });
    setEditInputFlag((prevState) => {
      return { ...prevState, editFlagBusinessRegistrationNo: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errBusinessRegistrationNo: "" };
    });
  };

  const handleModelChange = (model) => {
    setDescription(model);
    if (editFlag) {
      if (model === undefined || model === "" || !model) {
        setErr_Display((prevState) => {
          return {
            ...prevState,
            errCompanyProfile: "Business description is required!",
          };
        });
      } else {
        setErr_Display((prevState) => {
          return {
            ...prevState,
            errCompanyProfile: "",
          };
        });
      }
    }
  };

  const SaveHandler = (e) => {
    e.preventDefault();
    let check = true;

    const EmailValidation = EmailCheck(userInput.editBusinessEmail);

    const BusinessNameValidation = FirstNameCheck(
      editInputFlag.editFlagBusinessName === true
        ? userInput.editBusinessName
        : UserData.business_name
    );

    const BusinessRegistrationValidation = onlyNumberCheck(
      editInputFlag.editFlagBusinessRegistrationNo === true
        ? userInput.editBusinessRegistrationNo
        : UserData.business_registration_no
    );

    const BusinessEmailValidation = EmailCheck(
      editInputFlag.editFlagBusinessEmail === true
        ? userInput.editBusinessEmail
        : UserData.business_contact_email
    );

    // const MetaTitleValidation = MetaTitleCheck(
    //   editInputFlag.editFlagMetaTitle === true
    //     ? userInput.editMetaTitle
    //     : UserData.meta_title
    // );

    // const MetaDescriptionValidation = MetaDescriptionCheck(
    //   editInputFlag.editFlagMetaDescription === true
    //     ? userInput.editMetaDescription
    //     : UserData.meta_description
    // );

    if (BusinessNameValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errBusinessName: "Business name is required!",
        };
      });
      check = false;
    }

    // if (MetaTitleValidation.input === "empty") {
    //   setErr_Display((prevState) => {
    //     return {
    //       ...prevState,
    //       errMetaTitle: "Meta title is required!",
    //     };
    //   });
    //   check = false;
    // }

    // if (MetaDescriptionValidation.input === "empty") {
    //   setErr_Display((prevState) => {
    //     return {
    //       ...prevState,
    //       errMetaDescription: "Meta description is required!",
    //     };
    //   });
    //   check = false;
    // }

    if (selectedCertifications.length === 0) {
      check = false;
      setErr_Display((prevState) => ({
        ...prevState,
        errBusinessCertification: "Please select at least one certification!",
      }));
    }

    if (BusinessRegistrationValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errBusinessRegistrationNo: "Business registeration no. is required!",
        };
      });
      check = false;
    }

    if (BusinessEmailValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errBusinessEmail: "Business email is required!",
        };
      });
      check = false;
    } else if (BusinessEmailValidation.input === "invalid") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errBusinessEmail: EmailValidation.err_display,
        };
      });
      check = false;
    }

    if (mobileNumber.length === 0) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errBusinessContact: "Business contact is required!",
        };
      });
      check = false;
    }

    // if (description === undefined || description === "" || !description) {
    //   check = false;
    //   setErr_Display((prevState) => {
    //     return {
    //       ...prevState,
    //       errCompanyProfile: "Business description is required!",
    //     };
    //   });
    // }

    const plainText = stripHTML(description);
    const currentCharCount = plainText.length;
    const hasInvalidTags = /<img|<figure/i.test(description);
    if (description === undefined || description === "" || !description) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errCompanyProfile: "Business description is required!",
        };
      });
      check = false;
    } else if (
      hasInvalidTags &&
      currentCharCount > max_character_count
    ) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errCompanyProfile: `Character limit exceeded! You can only enter up to ${max_character_count} characters, and images are not allowed.`,
        };
      });
      check = false;
    } else if (hasInvalidTags) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errCompanyProfile: ErrorMessage.ImageError,
        };
      });
      check = false;
    } else if (currentCharCount > max_character_count) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errCompanyProfile: `Character limit exceeded! You can only enter up to ${max_character_count} characters.`,
        };
      });
      check = false;
    } else {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errCompanyProfile: "",
        };
      });
      check = true;
    }

    const isErrorFree = Object.values(err_Display).every(
      (value) => value === ""
    );

    if (isErrorFree && editFlag === true && check) {
      const MobileFormated = mobileNumber.replace(/-/g, "");

      let UpdateCredentials = {
        business_name:
          editInputFlag.editFlagBusinessName === true
            ? userInput.editBusinessName.trim()
            : UserData.business_name,

        number_of_employee:
          editInputFlag.editFlagNumberOfEmployees === true
            ? userInput.editNumberOfEmployees
            : UserData.number_of_employee,

        business_registration_no:
          editInputFlag.editFlagBusinessRegistrationNo === true
            ? userInput.editBusinessRegistrationNo.trim()
            : UserData.business_registration_no,

        meta_title:
          editInputFlag.editFlagMetaTitle === true
            ? userInput.editMetaTitle.trim()
            : UserData.meta_title,

        meta_description:
          editInputFlag.editFlagMetaDescription === true
            ? userInput.editMetaDescription.trim()
            : UserData.meta_description,

        business_contact_email:
          editInputFlag.editFlagBusinessEmail === true
            ? userInput.editBusinessEmail
            : UserData.business_contact_email,

        business_contact_mobile: MobileFormated,
        owned_gender: selectedCertifications,

        business_description: description ?? "",
        bu_id: parseInt(Bu_Id),
        api_method: "post",
      };

      UpdateMyProfileBusinessInfo(UpdateCredentials);

      setErr_Display(() => {
        return {
          errBusinessName: "",
          errBusinessCategory: "",
          errBusinessRegistrationNo: "",
          errCompanyProfile: "",
          errNumberOfEmployees: "",
          errBusinessEmail: "",
          errBusinessContact: "",
          errBusinessCertification: "",
          errMetaTitle: "",
          errMetaDescription: "",
        };
      });
    } else {
      console.log("Data missing");
    }
  };

  const GetMyProfileBusinessInfo = async () => {
    const data = { bu_id: parseInt(Bu_Id), api_method: "get" };

    setLoading(true);
    const MyProfileInfoData = await BusinessInfoAPI(data);
    setLoading(false);
    if (MyProfileInfoData.status === 200) {
      setLoading(false);
      setUserData(MyProfileInfoData.data[0]);
      setSelectedCertifications(MyProfileInfoData.data[0].owned_gender || []);
      let digits = MyProfileInfoData?.data[0]?.business_contact_mobile?.replace(
        /\D/g,
        ""
      );
      digits = digits?.substring(0, 10);
      let formatted = digits;
      if (digits?.length > 3) {
        formatted = digits.substring(0, 3) + "-" + digits.substring(3);
      }
      if (digits?.length > 6) {
        formatted = formatted.substring(0, 7) + "-" + formatted.substring(7);
      }
      setMobileNumber(formatted);
      setDescription(
        MyProfileInfoData?.data[0]?.company_profile
          ? MyProfileInfoData?.data[0]?.company_profile
          : ""
      );
      setUserInput((ps) => {
        return {
          ...ps,
          editBusinessName: MyProfileInfoData?.data[0]?.business_name
            ? MyProfileInfoData?.data[0]?.business_name
            : "",

          editNumberOfEmployees: MyProfileInfoData?.data[0]?.number_of_employee
            ? MyProfileInfoData?.data[0]?.number_of_employee
            : "",

          editBusinessRegistrationNo: MyProfileInfoData?.data[0]
            ?.business_registration_no
            ? MyProfileInfoData?.data[0]?.business_registration_no
            : "",

          editMetaTitle: MyProfileInfoData?.data[0]?.meta_title
            ? MyProfileInfoData?.data[0]?.meta_title
            : "",

          editMetaDescription: MyProfileInfoData?.data[0]?.meta_description
            ? MyProfileInfoData?.data[0]?.meta_description
            : "",

          editBusinessEmail: MyProfileInfoData?.data[0]?.business_contact_email
            ? MyProfileInfoData?.data[0]?.business_contact_email
            : "",

          editBusinessContact: formatted ? formatted : "",

          editCompanyProfile: MyProfileInfoData?.data[0]?.company_profile
            ? MyProfileInfoData?.data[0]?.company_profile
            : "",
        };
      });
    } else {
      setLoading(false);
      toast.error(MyProfileInfoData.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  const UpdateMyProfileBusinessInfo = async (data) => {
    setLoading(true);
    const MyProfileInfoData = await BusinessInfoAPI(data);
    setLoading(false);
    if (MyProfileInfoData.success === true) {
      toast.success("Updated profile successfully!", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setEditFlag(false);

      GetMyProfileBusinessInfo();
    } else if (MyProfileInfoData.status === 429) {
      setLoading(true);
      toast.error(MyProfileInfoData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      toast.error(MyProfileInfoData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    GetMyProfileBusinessInfo();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <Row>
        <p>
          To make any changes, click on edit button, make the changes and click
          on save button.
        </p>
        <Col lg="12">
          <p className="page-maintitle pr-2">
            <div className="text-right two-btns mr-5">
              {editFlag === true ? (
                <Button
                  className="green-btn btn-margin"
                  onClick={(e) => SaveHandler(e)}
                >
                  Save
                </Button>
              ) : (
                <Button className="green-btn btn-margin" onClick={EditHandler}>
                  <MdEdit className="mb-1" />
                  Edit
                </Button>
              )}
            </div>
          </p>
          <Form className="formmain mx-5 mt-4 signin-row profile-form pb-4 business-info-form">
            <Row>
              <Col md="12" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Business Name <span className="star-required">*</span>
                  </Form.Label>

                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editInputFlag.editFlagBusinessName === true
                          ? userInput.editBusinessName
                          : UserData.business_name
                      }
                      placeholder="Enter Business Name"
                      className="custom-formcontrol"
                      onChange={onBusinessName}
                      maxLength={100}
                      disabled={true}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errBusinessName} />
                </Form.Group>
              </Col>

              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Business Registration No{" "}
                    <span className="star-required">*</span>
                  </Form.Label>

                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      maxLength={15}
                      value={
                        editFlag === true
                          ? userInput.editBusinessRegistrationNo
                          : UserData.business_registration_no
                      }
                      placeholder="Enter Business Registration No"
                      className="custom-formcontrol"
                      disabled={editFlag === true ? false : true}
                      onChange={onBusinessRegistrationNo}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel
                    ErrorDisplay={err_Display.errBusinessRegistrationNo}
                  />
                </Form.Group>
              </Col>

              {/* {editFlag === true ? (
                <Col md="6" className="">
                  <Form.Group className="mb-0" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Business Category <span className="star-required">*</span>
                    </Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      className="custom-select"
                      onChange={onBusinessCategory}
                      value={
                        editInputFlag.editFlagBusinessCategory === true
                          ? userInput.editBusinessCategory
                          : UserData.bu_cat_id
                      }
                    >
                      {buCategory?.length > 0 ? (
                        buCategory.map((val) => {
                          return (
                            <option value={val.category_id}>
                              {val.category_name}
                            </option>
                          );
                        })
                      ) : (
                        <option value="0">{"No categories"}</option>
                      )}
                    </Form.Select>
                  </Form.Group>
                  <ErrorLabel ErrorDisplay={err_Display.errBusinessCategory} />
                </Col>
              ) : (
                <Col md="6" className="">
                  <Form.Group className="mb-0" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Business Category
                    </Form.Label>

                    <InputGroup className="edit-border test">
                      <Form.Control
                        type="text"
                        value={UserData.business_category}
                        className="custom-formcontrol"
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              )} */}

              {editFlag === true ? (
                <Col md="6" className="">
                  <Form.Group className="mb-0" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Number Of Employees{" "}
                      <span className="star-required">*</span>
                    </Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      className="custom-select"
                      onChange={onNumberOfEmployees}
                      value={userInput.editNumberOfEmployees}
                    >
                      <option value="0-10">0-10 employees</option>
                      <option value="11-25">11-25 employees</option>
                      <option value="26-50">26-50 employees</option>
                      <option value="51-100">51-100 employees</option>
                      <option value="101+">101+ employees</option>
                    </Form.Select>
                  </Form.Group>
                  <ErrorLabel ErrorDisplay={err_Display.errBusinessCategory} />
                </Col>
              ) : (
                <Col md="6" className="">
                  <Form.Group className="mb-0" controlId="formBasicEmail">
                    <Form.Label className="form-label-custom">
                      Number Of Employees{" "}
                      <span className="star-required">*</span>
                    </Form.Label>

                    <InputGroup className="edit-border">
                      <Form.Control
                        type="text"
                        value={UserData.number_of_employee}
                        placeholder="select Number of Employees"
                        className="custom-formcontrol"
                        disabled={true}
                        autoComplete="off"
                      />
                    </InputGroup>
                    <ErrorLabel
                      ErrorDisplay={err_Display.errNumberOfEmployees}
                    />
                  </Form.Group>
                </Col>
              )}

              <Col md="12">
                <Form.Group>
                  <Form.Label className="form-label-custom">
                    <div className="label-info-text">
                      Business Certification
                      <span className="star-required">*</span>
                      <p className="info-text-space">
                        &#40;Select all that apply&#41;
                      </p>
                    </div>
                  </Form.Label>
                  <Form className="mt-2">
                    {businessCertification?.map((item) => (
                      <div key={item}>
                        <Form.Check
                          label={item}
                          name={item}
                          type="checkbox"
                          disabled={!editFlag}
                          id={item}
                          onChange={handleCheckboxChange}
                          checked={selectedCertifications.includes(item)}
                        />
                      </div>
                    ))}
                  </Form>
                  <ErrorLabel
                    ErrorDisplay={err_Display.errBusinessCertification}
                  />
                </Form.Group>
              </Col>

              <Col md="12">
                <hr className="primary-hr" />
              </Col>
              <p className="soc-text mb-2">
                Business Contact Information{" "}
                <span style={{ color: "black" }}>
                  (This information will be seen for general public to contact
                  in regards to your business)
                </span>
              </p>

              <Col md="6">
                <Form.Group className="">
                  <Form.Label className="form-label-custom">
                    Business Email Address{" "}
                    <span className="star-required">*</span>
                  </Form.Label>
                  <Form.Control
                    // type="email"
                    placeholder="Enter Email Address"
                    className="custom-formcontrol"
                    onChange={onBusinessEmail}
                    disabled={!editFlag}
                    value={
                      editFlag === true
                        ? userInput.editBusinessEmail
                        : UserData.business_contact_email
                    }
                    maxLength={70}
                    autoComplete="off"
                  />
                  <ErrorLabel ErrorDisplay={err_Display.errBusinessEmail} />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group
                  className="mobile_Number"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="form-label-custom">
                    Business Contact Number
                    <span className="star-required">*</span>
                  </Form.Label>
                  <div className="sign_up_Mobile">
                    <Form.Control
                      className="custom-formcontrol"
                      value="+1"
                      disabled
                    />
                    <Form.Control
                      type="text"
                      placeholder="Enter Contact Number"
                      className="custom-formcontrol flex-1"
                      onChange={onBusinessContact}
                      disabled={!editFlag}
                      value={mobileNumber}
                      // maxLength={20}
                      autoComplete="off"
                    />
                  </div>
                  <ErrorLabel ErrorDisplay={err_Display.errBusinessContact} />
                </Form.Group>
              </Col>

              <Col md="12">
                <Form.Group className="mb-1" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom info-sec">
                    Description <span className="star-required">*</span>{" "}
                    <p className="info-text-space-f13">
                      &#40;To start from a new line, please press Shift +
                      Enter.&#41;
                    </p>
                  </Form.Label>
                  <span className="mb-2 span-italic-grey">
                    You can use &nbsp;
                    <a href="/shop-local-AI/business-profile" target="_blank">
                      CommunityX AI&nbsp;
                    </a>
                    function to enhance your business description
                  </span>
                  <div style={{ pointerEvents: editFlag ? "auto" : "none" }}>
                    <FroalaTextEditor
                      description={description}
                      setDescription={setDescription}
                      max_character_count={max_character_count}
                    />
                  </div>
                </Form.Group>
                <ErrorLabel ErrorDisplay={err_Display.errCompanyProfile} />
              </Col>

              <Col md="12">
                <hr className="primary-hr" />
              </Col>
              <p className="soc-text mb-2">Recommended</p>

              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Meta Title&nbsp;
                    {["top"].map((placement) => (
                      <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                          <Tooltip
                            id={`tooltip-${placement}`}
                            style={{ width: "50%" }}
                          >
                            A meta title is the title shown in search results
                            and browser tabs. Enter a short, keyword-rich title
                            under 60 characters.
                          </Tooltip>
                        }
                      >
                        <Image
                          loading="lazy"
                          src={iicon}
                          className="mb-1"
                          width="15px"
                        ></Image>
                      </OverlayTrigger>
                    ))}
                  </Form.Label>
                  <p className="info-text-space">
                    &#40;"Appears in the browser tab",Maximum characters
                    allowed: 60&#41;
                  </p>

                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editInputFlag.editFlagMetaTitle === true
                          ? userInput.editMetaTitle
                          : UserData.meta_title
                      }
                      placeholder="Enter Meta Title"
                      className="custom-formcontrol"
                      onChange={onMetaTitle}
                      maxLength={60}
                      disabled={!editFlag}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errMetaTitle} />
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Meta Description&nbsp;
                    {["top"].map((placement) => (
                      <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                          <Tooltip
                            id={`tooltip-${placement}`}
                            style={{ width: "50%" }}
                          >
                            A meta description is a brief summary of your page
                            that appears in search results. Enter a clear,
                            engaging description with important keywords, and
                            keep it under 160 characters.
                          </Tooltip>
                        }
                      >
                        <Image
                          loading="lazy"
                          src={iicon}
                          className="mb-1"
                          width="15px"
                        ></Image>
                      </OverlayTrigger>
                    ))}
                  </Form.Label>
                  <p className="info-text-space">
                    &#40;Maximum characters allowed: 160&#41;
                  </p>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editInputFlag.editFlagMetaDescription === true
                          ? userInput.editMetaDescription
                          : UserData.meta_description
                      }
                      placeholder="Enter Meta Description"
                      className="custom-formcontrol"
                      onChange={onMetaDescription}
                      maxLength={160}
                      disabled={!editFlag}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errMetaDescription} />
                </Form.Group>
              </Col>
            </Row>
            {editFlag === true ? (
              <div className="text-center small-btns d-flex">
                <Link onClick={CancelHandler}>
                  <p className="view">Cancel</p>
                </Link>
                <Button
                  variant="primary"
                  type="submit"
                  className="green-btn mt-3"
                  onClick={(e) => SaveHandler(e)}
                >
                  Save
                </Button>
              </div>
            ) : (
              <></>
            )}
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default MyProfileBusinessInfo;
